import Reveal from "../components/Reveal";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="pt-32 pb-20">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 prose prose-invert">
        <Reveal>
          <h1 className="text-5xl font-bold">
            Terms & <span className="flame-text">Conditions</span>
          </h1>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="text-zinc-400 mt-4">
            Last Updated: 15 May 2026
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="space-y-8 text-zinc-300 leading-relaxed mt-10">

            <Section title="1. Company Information">
              <p>
                Codeflare Labs is a legally operating partnership business entity registered in India with applicable GST compliance and business operations.
              </p>
              <p className="mt-3">
                Any reference to “Codeflare Labs”, “Company”, “We”, “Us”, or “Our” shall refer to the legally operating business entity of Codeflare Labs including its brands, divisions, platforms, services, products, training initiatives, educational platforms, and operational units.
              </p>
            </Section>

            <Section title="2. Codeflare Academy">
              <p>
                Codeflare Academy is an educational, training, internship, and skill-development initiative operated, managed, and owned by Codeflare Labs.
              </p>

              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Payments may be billed under Codeflare Labs.</li>
                <li>GST invoices and certificates may carry Codeflare Labs details.</li>
                <li>All legal protections and policies automatically apply to Codeflare Academy.</li>
              </ul>
            </Section>

            <Section title="3. Services Offered">
              <ul className="list-disc pl-6 space-y-2">
                <li>Website Development</li>
                <li>Software Development</li>
                <li>Mobile App Development</li>
                <li>SaaS Solutions</li>
                <li>AI & Automation Solutions</li>
                <li>ERP & CRM Development</li>
                <li>UI/UX Design</li>
                <li>API Integrations</li>
                <li>Cloud Solutions</li>
                <li>Cybersecurity Solutions</li>
                <li>Digital Marketing</li>
                <li>SEO & Social Media Marketing</li>
                <li>Performance Marketing</li>
                <li>BPO & Backend Operations</li>
                <li>Telecalling & Customer Support</li>
                <li>Technical Consulting</li>
                <li>Online & Offline Courses</li>
                <li>Internship Programs</li>
                <li>Industrial Training</li>
                <li>Workshops & Bootcamps</li>
              </ul>
            </Section>

            <Section title="4. Quotations, Agreements & Scope">
              <ul className="list-disc pl-6 space-y-2">
                <li>All quotations and proposals are confidential.</li>
                <li>Project scope and pricing are determined through written communication.</li>
                <li>Additional work outside agreed scope will be billed separately.</li>
                <li>Verbal commitments are not legally binding unless confirmed in writing.</li>
              </ul>
            </Section>

            <Section title="5. Payment Terms">
              <h3 className="text-lg font-semibold text-white mt-4">5.1 Development Projects</h3>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Small projects require 50% advance payment.</li>
                <li>Large projects may follow milestone-based payments.</li>
              </ul>

              <h3 className="text-lg font-semibold text-white mt-6">5.2 Marketing Services</h3>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Marketing charges are prepaid.</li>
                <li>Advertisement budgets are separate unless mentioned.</li>
              </ul>

              <h3 className="text-lg font-semibold text-white mt-6">5.3 Educational Services</h3>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Course and internship fees are generally prepaid.</li>
                <li>Seats are allocated on first-come-first-served basis.</li>
                <li>Certificates may require assignment and attendance completion.</li>
              </ul>
            </Section>

            <Section title="6. Refund Policy">
              <ul className="list-disc pl-6 space-y-2">
                <li>Advance payments are generally non-refundable.</li>
                <li>Third-party costs including domains, hosting, APIs, plugins, and cloud services are non-refundable.</li>
                <li>Educational and internship program fees are non-refundable once registration is completed.</li>
              </ul>
            </Section>

            <Section title="7. Taxes & GST">
              <ul className="list-disc pl-6 space-y-2">
                <li>All invoices are subject to applicable GST.</li>
                <li>Educational payments may also be invoiced under Codeflare Labs.</li>
                <li>Unpaid invoices may affect compliance records.</li>
              </ul>
            </Section>

            <Section title="8. Delayed Payments & Suspension">
              <ul className="list-disc pl-6 space-y-2">
                <li>Services may be paused for unpaid invoices.</li>
                <li>Hosting, deployment, educational access, or service availability may be suspended without prior notice.</li>
              </ul>
            </Section>

            <Section title="9. Maintenance & Support Policy">
              <p>
                Maintenance includes bug fixes, security updates, monitoring, and minor modifications only.
              </p>
              <p className="mt-3">
                New features, redesigns, advanced integrations, and redevelopment are billed separately.
              </p>
            </Section>

            <Section title="10. Third-Party Services & External Costs">
              <ul className="list-disc pl-6 space-y-2">
                <li>Domain registration</li>
                <li>Hosting/server charges</li>
                <li>Cloud infrastructure</li>
                <li>API charges</li>
                <li>AI model costs</li>
                <li>SMS/Email gateways</li>
                <li>Advertisement budgets</li>
              </ul>
            </Section>

            <Section title="11. Cookies & Tracking Technologies">
              <p>
                Our platforms may use cookies and tracking technologies to improve user experience, analytics, and performance.
              </p>
            </Section>

            <Section title="12. Data Collection & Privacy">
              <p>
                We may collect information including name, email, phone number, billing details, device/browser information, IP address, and submitted forms/content.
              </p>
            </Section>

            <Section title="13. Third-Party Storage & Data Processing">
              <p>
                User data may be processed using trusted third-party providers such as cloud hosting providers, payment gateways, CRM systems, analytics tools, and AI providers.
              </p>
            </Section>

            <Section title="14. Intellectual Property Rights">
              <ul className="list-disc pl-6 space-y-2">
                <li>All source code and materials remain property of Codeflare Labs unless agreed otherwise.</li>
                <li>Ownership transfer occurs only after full payment clearance.</li>
                <li>Unauthorized copying or redistribution is prohibited.</li>
              </ul>
            </Section>

            <Section title="15. Training & Internship Policies">
              <ul className="list-disc pl-6 space-y-2">
                <li>Certificates require successful completion criteria.</li>
                <li>Internships or career guidance do not guarantee employment.</li>
                <li>Course structures and schedules may change without notice.</li>
              </ul>
            </Section>

            <Section title="16. Limitation of Liability">
              <p>
                Codeflare Labs shall not be liable for business losses, downtime, cyber attacks, API failures, educational outcomes, or third-party disruptions.
              </p>
            </Section>

            <Section title="17. Prohibited Activities">
              <ul className="list-disc pl-6 space-y-2">
                <li>Unauthorized access attempts</li>
                <li>Malicious activities or malware uploads</li>
                <li>Reverse engineering proprietary systems</li>
                <li>Sharing paid educational content publicly</li>
              </ul>
            </Section>

            <Section title="18. Force Majeure">
              <p>
                Codeflare Labs shall not be responsible for delays caused by natural disasters, outages, cyber incidents, wars, pandemics, or government restrictions.
              </p>
            </Section>

            <Section title="19. Modification of Terms">
              <p>
                Codeflare Labs reserves the right to modify these Terms & Conditions at any time without prior notice.
              </p>
            </Section>

            <Section title="20. Governing Law & Jurisdiction">
              <p>
                These Terms & Conditions are governed by the laws of India and subject exclusively to the jurisdiction of the Hon’ble High Court at Calcutta, West Bengal, India.
              </p>
            </Section>

            <Section title="21. Contact">
              <p>
                Official communications may be made through the official website, email addresses, invoices, quotations, agreements, or verified communication channels of Codeflare Labs.
              </p>
            </Section>

          </div>
        </Reveal>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-white mb-3">
        {title}
      </h2>
      {children}
    </div>
  );
}